import React from 'react';
import { Shield, Leaf, Briefcase, FileCheck, TrendingUp, Users } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { mockServices } from '../mock';

const Services = () => {
  const serviceCategories = [
    {
      id: 'health-safety',
      label: 'Health & Safety',
      icon: Shield,
      color: 'emerald',
      services: mockServices.healthSafety
    },
    {
      id: 'environmental',
      label: 'Environmental',
      icon: Leaf,
      color: 'green',
      services: mockServices.environmental
    },
    {
      id: 'business',
      label: 'Business Services',
      icon: Briefcase,
      color: 'teal',
      services: mockServices.other
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-emerald-600">Services</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive solutions tailored to your business needs
          </p>
        </div>

        {/* Services Tabs */}
        <Tabs defaultValue="health-safety" className="w-full">
          <TabsList className="grid w-full max-w-2xl mx-auto grid-cols-3 mb-12 h-auto p-2 bg-gray-100">
            {serviceCategories.map((category) => {
              const Icon = category.icon;
              return (
                <TabsTrigger
                  key={category.id}
                  value={category.id}
                  className="flex items-center justify-center space-x-2 py-3 data-[state=active]:bg-emerald-600 data-[state=active]:text-white transition-all duration-300"
                >
                  <Icon size={18} />
                  <span className="hidden sm:inline">{category.label}</span>
                </TabsTrigger>
              );
            })}
          </TabsList>

          {serviceCategories.map((category) => (
            <TabsContent key={category.id} value={category.id} className="mt-8">
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {category.services.map((service, index) => (
                  <Card
                    key={index}
                    className="hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-l-4 border-l-emerald-500"
                  >
                    <CardHeader>
                      <CardTitle className="text-lg font-semibold text-gray-900">
                        {service.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <CardDescription className="text-gray-600">
                        {service.description}
                      </CardDescription>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </section>
  );
};

export default Services;
